import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: "/",
        name: "首頁",
        component: () => import("./components/LoginModel.vue"),
    },
    {
        path: "/consentform",
        name: "consentform",
        component: () => import("./components/ConsentForm.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "/basic",
        name: "basic",
        component: () => import("./components/BasicForm.vue"),
        meta: { requiresAuth: false }, // 需要驗證
    },
    {
        path: "/education",
        name: "education",
        component: () => import("./components/EducationForm.vue"),
        meta: { requiresAuth: true }, // 需要驗證
    },
    {
        path: "/workexperience",
        name: "workexperience",
        component: () => import("./components/WorkExperienceForm.vue"),
        meta: { requiresAuth: true }, // 需要驗證
    },
    {
        path: "/uploadpic",
        name: "uploadpic",
        component: () => import("./components/UploadPIC.vue"),
        meta: { requiresAuth: true }, // 需要驗證
    },
    {
        path: "/:catchAll(.*)",
        name: "NotFound",
        component: () => import("./components/NotFound.vue"),
        meta: { hideAppBar: true },
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to, from, next) => {
    // 是否要驗證
    if (to.meta.requiresAuth) {
        const token = localStorage.getItem("jwtToken");
        // 檢查TOKEN是否過期
        if (!token || isTokenExpired(token)) {
            alert("尚未登入，請先登入！");
            return next({ path: "/" }); 
        }
    }
    next(); // 放行
});

// 檢查TOKEN是否過期
function isTokenExpired(token) {
    try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        const now = Math.floor(Date.now() / 1000);
        return payload.exp < now;
    } catch (error) {
        console.error("Token 解析失敗：", error);
        return true; // 解析失敗，無效
    }
}

export default router;